import React, { useState, useEffect, useContext,useRef } from "react";
import { Box, Grid, Typography, IconButton, Paper ,Avatar } from "@mui/material";
import useLocalStorage from "use-local-storage";
import { useNavigate } from "react-router-dom";
import { AppContext, siteName } from "../main";
import Navbar from "../layout/Navbar";
import { ArrowBackIos, ArrowForwardIos ,FormatQuote} from '@mui/icons-material';


const healthconfig= {
  title: "...",
  subtitle: "...",
  aboutSection: {
    sectionTitle: "Empowering Healthcare Providers With Accurate Billing Solutions",
    description: "We specialize in providing healthcare providers with precise, efficient, and efficient medical billing services...",
    image: "https://varefiles.s3.us-east-2.amazonaws.com/calendar_business-women-working-with-laptop-and-digital-tab-2023-11-27-04-49-42-utc.jpg",
    services: [
      {
        icon: "🧾",
        title: "Medical Billing",
        description: "Ensuring accuracy and efficiency..."
      },
      {
        icon: "🔄",
        title: "Revenue Cycle Management",
        description: "Streamlining your entire revenue cycle..."
      },
      {
        icon: "✅",
        title: "Compliance Consulting",
        description: "Keeping your operation in line..."
      }
    ]
  },
  testimonials: [
    {
      name: "Dr. Jane Smith",
      position: "XYZ Clinic",
      avatar: "https://your-server.com/avatar.jpg",
      message: "Since partnering with Accuracy Claims & Consulting...",
      rating: 5
    },
    {
      name: "Dr. John Doe",
      position: "ABC Clinic",
      avatar: "https://your-server.com/avatar2.jpg",
      message: "Our revenue improved significantly...",
      rating: 4
    }
  ]

  
}

const Nav = (props) => {

  const { handleEditItem, navOptions, navEdit = false } = props;
  const { appState, setAppState } = useContext(AppContext);
  const {  healthconfig= { }
   } = appState;

  // const [navbars, setNavbars] = useState({});
  const [myStore, setMyStore] = useLocalStorage("name", {});
  const { myInfo } = myStore;
  const navigate = useNavigate();


  const banner = "https://varefiles.s3.us-east-2.amazonaws.com/homehealth/banner2.jpg";

  return (<>
  <header id="header-wrap" style={{}}>
                  <Navbar
                    navEdit={true}
                  />
                       </header>
    <Box p={0} m={0} sx={{ backgroundColor: "#000", minHeight: "100vh" }}>



      {/* Hero Section */}
      <Box
        sx={{
          position: 'relative',
          height: '90vh',
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'hidden'
        }}
      >

        {/* Background Image */}
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundImage: `url(${banner})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            zIndex: 1
          }}
        />

        {/* Overlay */}
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0,0,0,0.7)',
            zIndex: 2
          }}
        />

        {/* Content */}
        <Box
          sx={{
            position: 'relative',
            zIndex: 3,
            px: 2,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: { xs: 'column', md: 'row' },
            gap: { xs: 4, md: 10 }
          }}
        >

          {/* Text */}
          <Box sx={{ maxWidth: "700px", textAlign: { xs: "center", md: "left" } }}>
            <Typography
              variant="h3"
              sx={{
                color: '#fff',
                fontWeight: 700,
                mb: 2,
                fontSize: { xs: '28px', sm: '36px', md: '48px' }
              }}
            >
              {healthconfig?.title || "Your Partner In Precise Medical Billing Solutions"}
            </Typography>

            <Typography
              variant="h6"
              sx={{
                color: '#ddd',
                fontSize: { xs: '16px', sm: '18px', md: '20px' }
              }}
            >
              {healthconfig?.subtitle || "Expert medical billing and consulting tailored to your healthcare needs."}
            </Typography>
          </Box>

          {/* Get Started Button */}
          <Box
            sx={{
              width: 160,
              height: 160,
              borderRadius: '50%',
              border: '2px solid white',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              position: 'relative'
            }}
          >
            <svg width="160" height="160" viewBox="0 0 200 200" style={{ position: 'absolute' }}>
              <defs>
                <path id="circlePath" d="M 100, 100 m -80, 0 a 80,80 0 1,1 160,0 a 80,80 0 1,1 -160,0" />
              </defs>

              <text fill="white" fontSize="12" fontWeight="bold" letterSpacing="3">
                <textPath xlinkHref="#circlePath" startOffset="0%">
                  GET STARTED • GET STARTED • 
                </textPath>
              </text>
            </svg>

            <Box
              sx={{
                fontSize: 40,
                color: '#39d353',
                transform: 'rotate(-45deg)',
                zIndex: 5
              }}
            >
              ↑
            </Box>
          </Box>

        </Box>


      </Box>
      <Box>
  <AboutSection />
</Box>
    </Box>
 </> );
};

export default Nav;




const AboutSection = () => {
  const { appState } = useContext(AppContext);
  const { healthconfig = {} } = appState;
  const { aboutSection = {} } = healthconfig;

  const scrollRef = useRef();

  const scroll = (direction) => {
    const scrollAmount = 300;
    if (direction === 'left') {
      scrollRef.current.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    } else {
      scrollRef.current.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }
  };

  return (
    <Box sx={{ py: 10, px: { xs: 2, md: 8 }, backgroundColor: '#fff' }}>
      
      {/* Section Label */}
      <Typography sx={{ color: '#39d353', fontWeight: 600, mb: 2 }}>
        About Us
      </Typography>

      {/* Top Section */}
      <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: 5, alignItems: 'center' }}>
        
        {/* Text */}
        <Box sx={{ flex: 1 }}>
          <Typography variant="h4" sx={{ fontWeight: 700, mb: 3, color: "#000" }}>
            {aboutSection.sectionTitle || "Empowering Healthcare Providers With Accurate Billing Solutions"}
          </Typography>

          <Typography sx={{ color: '#333', fontSize: 16 }}>
            {aboutSection.description || "We specialize in providing healthcare providers with precise, efficient and dedicated medical billing services..."}
          </Typography>
        </Box>

        {/* Image */}
        <Box sx={{ position: 'relative', flex: 1 }}>
          <Box
            component="img"
            src={aboutSection.image || "https://varefiles.s3.us-east-2.amazonaws.com/calendar_business-women-working-with-laptop-and-digital-tab-2023-11-27-04-49-42-utc.jpg" || "https://via.placeholder.com/600x400"}
            alt="About"
            sx={{
              width: '100%',
              borderRadius: '20px',
              objectFit: 'cover'
            }}
          />

          <Box
            sx={{
              position: 'absolute',
              bottom: 20,
              right: 20,
              width: 80,
              height: 80,
              borderRadius: '50%',
              border: '2px solid #000',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}
          >
            <Typography sx={{ fontSize: 30, color: '#39d353', transform: 'rotate(-45deg)' }}>↑</Typography>
          </Box>
        </Box>
      </Box>

      {/* Services Title */}
      

      {/* Carousel */}
      <Box sx={{ position: 'relative' }}>
        <Box sx={{
          display: 'flex',
          overflowX: 'auto',
          scrollBehavior: 'smooth',
          gap: 3,
          pb: 2
        }} ref={scrollRef}>
          {(aboutSection.services || []).map((service, idx) => (
            <Box key={idx} sx={{ minWidth: 280, flexShrink: 0 }}>
              <Paper elevation={3} sx={{ p: 4, borderRadius: 4 }}>
                <Typography sx={{ fontSize: 40, mb: 2 }}>{service.icon}</Typography>
                <Typography sx={{ fontWeight: 600, mb: 1, color: "#000" }}>{service.title}</Typography>
                <Typography sx={{ color: '#555' }}>{service.description}</Typography>
              </Paper>
            </Box>
          ))}
        </Box>

        {/* Arrows */}
     <ServicesSection />
     <TestimonialCarousel />
      </Box>
    </Box>
  );
};



const ServicesSection = () => {
  const { appState } = useContext(AppContext);
  const { healthconfig = {} } = appState;
  const { aboutSection = {
    sectionTitle: "Empowering Healthcare Providers With Accurate Billing Solutions",
    description: "We specialize in providing healthcare providers with precise, efficient, and efficient medical billing services...",
    image: "https://varefiles.s3.us-east-2.amazonaws.com/calendar_business-women-working-with-laptop-and-digital-tab-2023-11-27-04-49-42-utc.jpg",
    services: [
      {
        icon: "🧾",
        title: "Medical Billing",
        description: "Ensuring accuracy and efficiency..."
      },
      {
        icon: "🔄",
        title: "Revenue Cycle Management",
        description: "Streamlining your entire revenue cycle..."
      },
      {
        icon: "✅",
        title: "Compliance Consulting",
        description: "Keeping your operation in line..."
      }
    ]
  } } = healthconfig;

  const services = aboutSection?.services || [];

  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 3;

  const maxPages = Math.ceil(services.length / itemsPerPage);

  const handleNext = () => {
    if (currentPage < maxPages - 1) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrev = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
  };

  const visibleServices = services.slice(
    currentPage * itemsPerPage,
    (currentPage + 1) * itemsPerPage
  );

  return (
    <Box sx={{ py: 10, px: { xs: 2, md: 10 }, textAlign: 'center', backgroundColor: "#fff" }}>
      
      <Typography variant="h4" sx={{ fontWeight: 700, mb: 2, color: "#000" }}>
        Comprehensive Medical Billing & Consulting Services
      </Typography>

      <Typography sx={{ color: '#777', mb: 5 }}>
        We offer a full range of services designed to meet the needs of healthcare providers of all sizes.
      </Typography>

      <Box sx={{ position: 'relative', mb: 5 }}>
        <Grid container spacing={4} justifyContent="center">
          {visibleServices.map((service, idx) => (
            <Grid item xs={12} sm={4} key={idx}>
              <Paper elevation={1} sx={{
                p: 4, borderRadius: 5, border: '1px solid #ddd',
                height: '100%', display: 'flex', flexDirection: 'column',
                alignItems: 'center', justifyContent: 'center'
              }}>
                <Box sx={{ mb: 2 }}>
                  <img src={service.icon} alt={service.title} style={{ height: 60 }} />
                </Box>
                <Typography variant="h6" sx={{ fontWeight: 600, color: "#000", mb: 1 }}>
                  {service.title}
                </Typography>
                <Typography sx={{ color: '#666', fontSize: 14 }}>
                  {service.description}
                </Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>

        {/* Navigation Buttons */}
       
      </Box>
    </Box>
  );
};



const TestimonialCarousel = () => {
  const { appState } = useContext(AppContext);
  const { healthconfig = {} } = appState;
  const { testimonials = [
    {
      name: "Dr. Jane Smith",
      position: "XYZ Clinic",
      avatar: "https://your-server.com/avatar.jpg",
      message: "Since partnering with Accuracy Claims & Consulting...",
      rating: 5
    },
    {
      name: "Dr. John Doe",
      position: "ABC Clinic",
      avatar: "https://your-server.com/avatar2.jpg",
      message: "Our revenue improved significantly...",
      rating: 4
    }
  ]
 } = healthconfig;

  const [activeIndex, setActiveIndex] = useState(0);

  const prev = () => {
    setActiveIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const next = () => {
    setActiveIndex((prev) => (prev + 1) % testimonials.length);
  };

  return (
    <Box sx={{ py: 10, px: { xs: 2, md: 10 }, textAlign: 'center', backgroundColor: "#fff" }}>
      <Typography variant="h4" sx={{ fontWeight: 700, mb: 6, color: "#000" }}>
        What Our Clients Are Saying
      </Typography>

      <Box sx={{ position: 'relative', height: 300, overflow: 'hidden' }}>
        {testimonials.map((item, idx) => {
          const isActive = idx === activeIndex;
          const isLeft = idx === (activeIndex - 1 + testimonials.length) % testimonials.length;
          const isRight = idx === (activeIndex + 1) % testimonials.length;

          let scale = 0.5;
          let opacity = 0.3;
          let zIndex = 1;

          if (isActive) {
            scale = 1;
            opacity = 1;
            zIndex = 3;
          } else if (isLeft || isRight) {
            scale = 0.8;
            opacity = 0.6;
            zIndex = 2;
          }

          return (
            <Box
              key={idx}
              sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: `translate(-50%, -50%) scale(${scale})`,
                opacity,
                zIndex,
                width: 400,
                transition: 'all 0.5s ease',
                border: '1px solid #ddd',
                borderRadius: 4,
                backgroundColor: '#fff',
                p: 4
              }}
            >
              <FormatQuote sx={{ color: '#39d353', fontSize: 40, mb: 2 }} />
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <Avatar src={item.avatar} sx={{ mr: 2, width: 50, height: 50 }} />
                <Box>
                  <Typography sx={{ fontWeight: 700, color: "#000" }}>{item.name}</Typography>
                  <Typography sx={{ color: '#999' }}>{item.position}</Typography>
                </Box>
              </Box>

              <Typography sx={{ color: '#555', mb: 2 }}>{item.message}</Typography>

              <Box sx={{ color: '#39d353', fontSize: 20 }}>
                {'★'.repeat(item.rating)}{'☆'.repeat(5 - item.rating)}
              </Box>
            </Box>
          );
        })}

       
      </Box>
    </Box>
  );
};







